import { CartItem } from "@omni/types/api/cart/bff/shared/cartItem.model";
import { useEffect } from "react";

import { useThunkDispatch } from "@/redux/dispatcher";
import { CTAAction } from "@/redux/modules/api/data/cart/@types/cart.types";
import * as CartModule from "@/redux/modules/api/data/cart/cart.module";
import { useCallToActionsContext } from "@/utils/callToActions/callToActions.provider";

type Props = {
    product: CartItem | null;
};

const RemoveArticleAction = ({ product }: Props) => {
    const dispatch = useThunkDispatch();
    const { closeDialog, setLoading } = useCallToActionsContext();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (product) {
            setLoading(true);
            dispatch(
                product.free && !product.freeEntryAddedByCustomer
                    ? CartModule.removeFreeArticleFromCart(product.id!, product)
                    : CartModule.removeFromCart(
                          product.id!,
                          product.quantity,
                          product.free
                      )
            ).then((action) => {
                if (action.type === CartModule.APIStatus.SUCCESS) {
                    closeDialog();
                }
            });
        }
    }, []);

    return null;
};

const RemoveArticle: CTAAction = (product: CartItem | null) => (
    <RemoveArticleAction product={product} />
);

export default RemoveArticle;
